import { WithChildren } from '@optimus-web/common';
import { createSafeContext, useSafeUrlState } from '@mews/framework';
import {
    FilterContextNames,
    ExtendedFilterContextValues,
    useFilterState,
    useSelectedDateState,
} from '../../common/context/FilterContext';
import { DepositLedgerFilterValues, urlSchema } from '../schema';
import { defaultDepositLedgerFilterValues as defaultValues } from '../components/defaultDepositLedgerFilterValues';

const { DepositLedgerFilterContextProvider, useDepositLedgerFilterContext } = createSafeContext<
    FilterContextNames.DEPOSIT_LEDGER,
    Omit<ExtendedFilterContextValues<DepositLedgerFilterValues>, 'pagination' | 'setPagination' | 'resetPagination'>
>(FilterContextNames.DEPOSIT_LEDGER);

export const DepositLedgerFilterProvider: React.FC<WithChildren> = ({ children }) => {
    const [urlState] = useSafeUrlState(urlSchema);

    const filterState = useFilterState<DepositLedgerFilterValues>(urlState?.filterValues ?? defaultValues);
    const selectedDateState = useSelectedDateState(urlState?.date ?? undefined);

    return (
        <DepositLedgerFilterContextProvider value={{ ...filterState, ...selectedDateState }}>
            {children}
        </DepositLedgerFilterContextProvider>
    );
};

export const useDepositLedgerSelectedDate = () => {
    const { selectedDate, setSelectedDate } = useDepositLedgerFilterContext();
    return { selectedDate, setSelectedDate };
};

export { useDepositLedgerFilterContext };
